import Logo from './image0.png'

export default function Contact(){
    return(
    <div className='App'>
    <img src={Logo} className='logo' alt="logo" />
        <header className='App-header'>
            <h1>Contact Us!</h1>
            <br></br>
            <br></br>
            <h2>Rod Holloway</h2>
            <h3>Roderick.j.Holloway@gmail.com</h3>
            <h2>304-620-1743</h2>
            <br></br>
            <br></br>
            <br></br>
            <br></br>       
            <br></br>       
        </header>

    </div>
    )}